<div mat-dialog-content>
  <img lib-image image="check-example.png" />
</div>
